import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {PatientExtended} from '@/features/patients/types'
import {treatmentRequestStatusToLabel, treatmentRequestEligibilityStatusToLabel} from '../../utils'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {Trans, useTranslation} from '@/translations/i18n'
import {useTheme} from 'styled-components'
import {StyledDetailsInformationPrimaryTextError, StyledDetailsInformationSecondaryText} from './style'
import {useMemo} from 'react'
import {Text} from '@/components/ui/text/Text'

export const TreatmentRequestPatientUneligible = ({patient}: {patient: PatientExtended}) => {
    const {t} = useTranslation()
    const {palette} = useTheme()

    const errorCode = useMemo(
        () => patient.treatmentRequestEligibility.error?.code,
        [patient.treatmentRequestEligibility.error]
    )

    return (
        <Flexbox direction="column" gap={2}>
            <AlertCircleIcon size={15} color={palette.orange['600']} />
            <Flexbox direction="column" gap={0.5}>
                {!errorCode ? (
                    <Text size="textSm" palette="neutral" shade="500">
                        {t('errors:default')}
                    </Text>
                ) : (
                    <>
                        <StyledDetailsInformationPrimaryTextError weight="500" size="textMd">
                            {t(treatmentRequestEligibilityStatusToLabel[errorCode])}
                        </StyledDetailsInformationPrimaryTextError>
                        {errorCode == 'patient-on-shared-waiting-list' && (
                            <StyledDetailsInformationSecondaryText palette="neutral" shade="500" size="textSm">
                                <Trans
                                    i18nKey="treatment_requests:uneligible_patient_on_shared_waiting_list"
                                    values={{value: patient.domicile?.municipality?.name}}
                                    components={{b: <b />}}
                                />
                            </StyledDetailsInformationSecondaryText>
                        )}
                        {errorCode == 'resident-outside-the-region' && (
                            <StyledDetailsInformationSecondaryText palette="neutral" shade="500" size="textSm">
                                {t('treatment_requests:creation_failed')}
                            </StyledDetailsInformationSecondaryText>
                        )}
                        {errorCode == 'pri-in-progress' && (
                            <StyledDetailsInformationSecondaryText palette="neutral" shade="500" size="textSm">
                                <Trans
                                    i18nKey="treatment_requests:uneligible_pri_in_progress"
                                    values={{value: t('errors:missing_data')}} // todo: update this after PRI deployment
                                    components={{b: <b />}}
                                />
                            </StyledDetailsInformationSecondaryText>
                        )}
                        {errorCode == 'request-already-exists' && (
                            <StyledDetailsInformationSecondaryText palette="neutral" shade="500" size="textSm">
                                <Trans
                                    i18nKey="treatment_requests:uneligible_request_already_exists"
                                    values={{
                                        value:
                                            patient.treatmentRequest?.status &&
                                            t(treatmentRequestStatusToLabel[patient.treatmentRequest.status])
                                    }}
                                    components={{b: <b />}}
                                />
                            </StyledDetailsInformationSecondaryText>
                        )}
                        {errorCode == 'patient-deceased' && (
                            <StyledDetailsInformationSecondaryText palette="neutral" shade="500" size="textSm">
                                {t('treatment_requests:creation_failed')}
                            </StyledDetailsInformationSecondaryText>
                        )}
                    </>
                )}
            </Flexbox>
        </Flexbox>
    )
}
